<template>
    <span class="text-danger" @click="mostrarJustificativa()">
        <i
            class="fa fa-asterisk icon-button"
            :title="
                `Data de previsão reprogramada: ${entrega.justificativaDataPrevisaoReprogramada}`
            "
        ></i
    ></span>
</template>

<script>
export default {
    props: {
        entrega: {
            type: Object
        }
    },
    methods: {
        mostrarJustificativa() {
            this.$swal({
                title: 'Justificativa da Data de Previsão Reprogramada',
                html: this.entrega.justificativaDataPrevisaoReprogramada,
                icon: 'info'
            })
        }
    }
}
</script>
